// TinyMCE's self-hosted models/themes/plugins are legacy IIFEs that read a runtime
// `window.tinymce` global (they never import the core). Bundlers see no dependency edge
// from those submodules to the core, so the core MUST be evaluated — and the global set —
// before any submodule import. Importing this module first guarantees that ordering.
import tinymce from 'tinymce';

window.tinymce = tinymce;
window.tinyMCE = tinymce;

export default tinymce;
